const path = {
    home: '/',
    about: '/about',
    contact: '/contact',
    news: '/news',
    blog: '/blog',
    delete_account: '/delete-account',
    article: 'article',
    events: '/events',
    instructors: 'instructors',
    gallery: 'gallery',
    donation: 'donation',
    news_details: '/news-details',
    news_details_dy: '/news-details/:slug',
    courses_new: '/courses-list',
    course_details_dy: "/courses-details/:slug",
    courses_details: "/courses-details",
    course_enroll: '/course-enroll',
    course_enroll_dy: '/course-enroll/:slug',
    certificate: '/certificate',
    quiz: '/quiz',
    course_update: '/course-update',
    course_update_dy: '/course-update/:course_id/:status',
    course_create: '/profile/course-create',
    cart: '/cart',
    faq: '/faq',
    dashboard: '/dashboard',
    view_profile: '/profile/view-profile',
    view_profile_course: '/profile/my-course',
    view_instructor_course: '/profile/view-instructor-course',
    profile_setting: '/profile/setting',
    payment_history: '/payment-history',
    order_details: '/order-details',
    books_order_details: '/publishing/publications/order-details',
    wishlist: '/wishlist',
    public_profile_courses: `/instructor-details/public-profile-course`,
    view_public_profile: `/instructor-details/view-public-profile`,
    enroll_student_list: '/profile/view-instructor-course',
    enroll_student_list_dy: '/profile/view-instructor-course/:course_id',
    enroll_course_certificate_list: '/profile/view-instructor-course/ac/',
    enroll_course_certificate_list_dy: '/profile/view-instructor-course/ac/:course_id',
    student_result: '/profile/view-instructor-course',
    student_result_dy: '/profile/view-instructor-course/:course_id/:user_id',
    student_live_sessions: '/profile/live-sessions/student-running',
    student_live_sessions_invited: '/profile/live-sessions/student-invited',
    instructor_live_sessions_path: '/profile/live-sessions',
    instructor_live_sessions: '/profile/live-sessions/running',
    instructor_live_private: '/profile/live-sessions/unpublished',
    instructor_live_draft: '/profile/live-sessions/draft',
    instructor_live_upcoming: '/profile/live-sessions/not_started',
    instructor_live_completed: '/profile/live-sessions/ended',
    instructor_live_session_details: '/profile/live-sessions/details',
    login: '/login',
    registration: '/registration',
    ragistration_dy: '/registration?apply=become-instructor',
    registration_confirmation: '/registration-confirmation',
    registration_phone_confirmation: '/registration-phone-confirmation',
    confirm_signup: '/global/confirm-signup/',
    forget_password: '/forget-password',
    forget_password_confirm: '/forget-password-confirm',
    forget_password_mobile_confirm: '/forget-password-mobile-confirm',
    reset_password: '/reset-password/',
    error404: '/404',
    privacy_policy: '/privacy-policy',
    terms_of_service: '/terms-of-service',
    refund_policy: '/refund-policy',
    career: '/career',
    our_strength: '/our-strength',
    social_redirect_url: '/global/social-login-int',
    all_session_list: '/all-session',
    public_session_details: '/session/session-details',
    session_redirect_page: '/session-redirect',

    // Publishing routes
    publishing_books: '/publishing/publications',
    publishing_book_details: '/publishing/book-details',
    publishing_book_details_dy: '/publishing/book-details/:slug/:category_id',
    book_cart: '/publishing/publications/cart',
    book_checkout: '/publishing/publications/checkout',
    
    // publications routes
    publications: '/publications',
    book_details: '/book-details',
    book_details_dy: '/book-details/:slug',
};

export default path;
